import * as React from 'react';
const rowIdContext = React.createContext(undefined);
export const tableRowIdContextDefaultValue = '';
export const useTableRowIdContext = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(rowIdContext)) !== null && _React_useContext !== void 0 ? _React_useContext : tableRowIdContextDefaultValue;
};
export const TableRowIdContextProvider = rowIdContext.Provider;
